import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Input, Select, Button, Table, Modal, InputNumber } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  getKpiType,
  getUnitType,
  getInputType,
  updateKpi,
} from 'api/Project/kpifinance'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'
import { Data } from '@react-google-maps/api'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`
const { Option } = Select
const initalState = {
  data: [],
  isLoading: true,
}
let DataArray = {}

const AddTaskKPIFinance = (props) => {
  const {
    idEditPRJ,
    visableModal,
    setVisableModal,
    getResultKpi,
    stateKPI,
    dataEdit,
    typeBtn,
    titlePage,
  } = props
  const [kpiType, setKpiType] = useState(initalState.data)
  const [unitType, setUnitType] = useState(initalState.data)
  const [inputType, setInputType] = useState(initalState.data)
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')
  const companyIDUser = getCookie('companyId_project')
  // const [visableModal, setVisableModal] = useState(false)
  const [form] = Form.useForm()
  const [selectInputType, setSelectInputType] = useState()

  const [estimiteMin, setEstimiteMin] = useState(0)
  const [estimiteMax, setEstimiteMax] = useState(0)
  const [max, setMax] = useState()
  const [min, setMin] = useState(0)
  const [disableBtn, setDisableBtn] = useState()
  const [displayErrorMin, setDisplayErrorMin] = useState()
  const [displayErrorMax, setDisplayErrorMax] = useState()
  const [errorWordMax, setErrorWordMax] = useState()
  const [errorWordMin, setErrorWordMin] = useState()
  const [styleErrorMax, setStyleErrorMax] = useState()
  const [styleErrorMin, setStyleErrorMin] = useState()
  // const [countNumber, setCountNumber] = useState()
  const [maxValue, setMaxValue] = useState(5)
  const [selectedUnitName, setSelectedUnitName] = useState('')

  // call api
  const getResutlKpiType = async () => {
    getKpiType({
      id: parseInt(companyIDUser),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setKpiType([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          let updatedData = [...data]

          // ถ้าเป็นการ edit และมี dataEdit
          if (typeBtn === 'edit' && dataEdit?.kpi_type) {
            // ตรวจสอบว่า kpi_type จาก dataEdit มีใน data หรือไม่
            const existingKpiType = data.find((item) => item.id === dataEdit.kpi_type)

            if (!existingKpiType) {
              // ถ้าไม่มี ให้เพิ่มเข้าไป
              const inactiveKpiType = {
                id: dataEdit.kpi_type,
                company_id: parseInt(companyIDUser),
                company_code: '', // ไม่มีข้อมูลจาก dataEdit
                code: '', // ไม่มีข้อมูลจาก dataEdit
                name: dataEdit.kpi_type_name,
                name_en: dataEdit.kpi_type_name_en,
                account_id: null, // ไม่มีข้อมูลจาก dataEdit
                account_name: '', // ไม่มีข้อมูลจาก dataEdit
                status: 'Inactive', // ระบุว่าเป็น inactive
                created_at: '',
                updated_at: '',
                isInactive: true, // flag เพื่อระบุว่าเป็น inactive item
              }

              updatedData.push(inactiveKpiType)
            }
          }

          setKpiType(updatedData)
        } else {
          setKpiType([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setKpiType([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResutlUnitType = async () => {
    getUnitType({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setUnitType([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          let updatedData = [...data]

          // ถ้าเป็นการ edit และมี dataEdit
          if (typeBtn === 'edit' && dataEdit?.unit_type) {
            // ตรวจสอบว่า unit_type จาก dataEdit มีใน data หรือไม่
            const existingUnitType = data.find((item) => item.id === dataEdit.unit_type)

            if (!existingUnitType) {
              // ถ้าไม่มี ให้เพิ่มเข้าไป
              const inactiveUnitType = {
                id: dataEdit.unit_type,
                code: '', // ไม่มีข้อมูลจาก dataEdit
                name: dataEdit.unit_type_name,
                name_en: dataEdit.unit_type_name, // ใช้ unit_type_name เป็น name_en
                abbr: '', // ไม่มีข้อมูลจาก dataEdit
                account_id: null, // ไม่มีข้อมูลจาก dataEdit
                account_name: '', // ไม่มีข้อมูลจาก dataEdit
                status: 'Inactive', // ระบุว่าเป็น inactive
                created_at: '',
                updated_at: '',
                isInactive: true, // flag เพื่อระบุว่าเป็น inactive item
              }

              // เพิ่มที่ด้านบนสุด
              updatedData.unshift(inactiveUnitType)
            }
          }

          setUnitType(updatedData)
        } else {
          setUnitType([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setUnitType([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResutlInputType = async () => {
    getInputType({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setInputType([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setInputType(data)
        } else {
          setInputType([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setInputType([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const [displayAlertRemaining, setDisplayRemaining] = useState('none')

  useEffect(() => {
    if (token) {
      setDisplayErrorMin('none')
      setDisplayErrorMax('none')
      setDisplayRemaining('none')
      setStyleErrorMax(
        'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
      )
      setStyleErrorMin(
        'ant-row ant-form-item ant-form-item-with-help ant-form-item-has-success',
      )
      setDisableBtn(false)
      getResutlKpiType()
      getResutlUnitType()
      getResutlInputType()
      setFieldValue()
    }
  }, [token, visableModal])

  const onChangeInputType = (e) => {
    setSelectInputType(e)
  }

  const onChangeGoals = (value) => {
    const valueNumber = Number(value)
    form.setFieldsValue({
      realtaskgoals: valueNumber.toFixed(2),
    })

    // if (value == '' || value == null) {
    //   form.setFieldsValue({
    //     realtaskgoals: 0,
    //   })
    // } else if (typeof value !== 'string') {
    //   form.setFieldsValue({
    //     realtaskgoals: value.toFixed(2),
    //   })
    // }

    if (typeBtn == 'edit') {
      let usegoal =
        titlePage == 'Project' ? dataEdit.usegoal : dataEdit.sprintflow_usegoal

      if (value == '' || value == null) {
        setDisplayRemaining('none')
      } else if (typeof value !== 'string') {
        if (value.toFixed(2) < usegoal) {
          setDisplayRemaining('')
        } else {
          setDisplayRemaining('none')
        }
      }
    }
  }
  const checkShowInputType = (type) => {
    if (type == 22) {
      return (
        <div>
          <h4 className="label">
            {stateKPI == 'project'
              ? word['addtask_kpi_title_modaladd_projectminmax']
              : word['addtask_kpi_title_modaladd_taskminmax']}
          </h4>
          <Row>
            <Col span={12} style={{ paddingRight: 4 }}>
              <Form.Item
                className={styleErrorMin}
                name="min"
                rules={[
                  {
                    pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                    message: word['Project_KPI/Finance_GoalMax'],
                  },
                  {
                    required: true,
                    message: word['Project_KPI/Finance_Goal'],
                  },
                ]}
              >
                <InputNumber
                  type="number"
                  className="border"
                  placeholder="Min"
                  onChange={(value) => onChangeValue('min', value)}
                  size="large"
                  // min={min}
                  // max={max}
                  max={9999999999999999.99}
                  style={{ width: '100%' }}
                  // maxLength={16}
                  step="0.00"
                ></InputNumber>
              </Form.Item>
              <div style={{ height: 24 }}>
                <div
                  style={{ display: displayErrorMin }}
                  class="ant-form-item-explain ant-form-item-explain-error"
                >
                  <div role="alert">{errorWordMin}</div>
                </div>
              </div>
            </Col>

            <Col span={12} style={{ paddingLeft: 4 }}>
              <Form.Item
                className={styleErrorMax}
                name="max"
                rules={[
                  {
                    pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                    message: word['Project_KPI/Finance_GoalMax'],
                  },
                  {
                    required: true,
                    message: word['Project_KPI/Finance_Goal'],
                  },
                ]}
              >
                <InputNumber
                  type="number"
                  onChange={(value) => onChangeValue('max', value)}
                  className="border"
                  placeholder="Max"
                  size="large"
                  style={{ width: '100%' }}
                  min={min != 0 ? min : estimiteMax}
                  // disabled
                  // maxLength={16}
                  max={9999999999999999.99}
                  step="0.00"
                ></InputNumber>
              </Form.Item>
              <div style={{ height: 24 }}>
                <div
                  style={{ display: displayErrorMax }}
                  class="ant-form-item-explain ant-form-item-explain-error"
                >
                  <div role="alert">{errorWordMax}</div>
                </div>
              </div>
            </Col>
            <Row style={{ marginTop: -15, marginBottom: 15 }}>
              <h4>Estimate ≈ </h4>
              <h4 style={{ marginLeft: 5, color: '#7C7C84' }}>
                {estimiteMin ? estimiteMin.toFixed(2) : 0}{' '}
              </h4>
              <h4 style={{ marginLeft: 5, marginRight: 5 }}>-</h4>{' '}
              <h4 style={{ color: '#7C7C84' }}>
                {' '}
                {estimiteMax ? estimiteMax.toFixed(2) : 0}{' '}
              </h4>
            </Row>
          </Row>
        </div>
      )
    } else {
      return (
        <div>
          <div className="disableless">
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <h4 className="label">
                {stateKPI == 'project'
                  ? word['addtask_kpi_title_modaladd_projectgoal']
                  : word['addtask_kpi_title_modaladd_taskgoal']}
              </h4>
              <div>
                <div
                  style={{ display: displayAlertRemaining }}
                  class="ant-form-item-explain ant-form-item-explain-error"
                >
                  <div role="alert">
                    {titlePage} goal is less than{' '}
                    {titlePage == 'Project' ? 'task' : 'subtask'}(
                    {typeBtn == 'edit'
                      ? titlePage == 'Project'
                        ? dataEdit.usegoal
                        : dataEdit.sprintflow_usegoal
                      : ''}
                    )
                  </div>
                </div>
              </div>
            </Row>

            <Form.Item
              name="projectgoal"
              rules={[
                {
                  pattern: /^-?[0-9]{1,16}(\.[0-9]{1,2})?$/,
                  message: word['Project_KPI/Finance_GoalMax'],
                },
                {
                  required: true,
                  message: word['Project_KPI/Finance_Goal'],
                },
              ]}
            >
              <InputNumber
                type="number"
                className="border"
                placeholder={stateKPI == 'project' ? 'Project Goal' : 'Task Goal'}
                size="large"
                //min={0}
                style={{ width: '100%' }}
                max={9999999999999999.99}
                // maxLength={maxValue}
                step="0.00"
                onChange={(e) => onChangeGoals(e)}
              />
            </Form.Item>
            <Row style={{ marginTop: 4 }}>
              <h4 style={{ marginTop: 8 }}>Estimate ≈</h4>
              <Form.Item id="realtaskgoals" name="realtaskgoals">
                <InputNumber
                  disabled
                  size="large"
                  style={{ width: '120%' }}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  step="0.00"
                />
              </Form.Item>
            </Row>
          </div>

          <div className="disable-page">
            <Col
              style={{ width: '100%' }}
              hidden={
                typeBtn == 'edit' ? (dataEdit?.input_type_id == 23 ? false : true) : true
              }
            >
              <h4 style={{ marginBottom: 8 }}>Remaining</h4>
              <Form.Item name="retaskgoals">
                <InputNumber
                  disabled
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                  size="large"
                  style={{ width: '100%' }}
                  step="0.00"
                  maxLength={12}
                />
              </Form.Item>
            </Col>
          </div>
        </div>
      )
    }
  }
  const setFieldValue = () => {
    if (typeBtn === 'edit') {
      setSelectInputType(dataEdit.input_type_id)
      if (dataEdit.input_type_id === 22) {
        form.setFieldsValue({
          kpitype: dataEdit.kpi_type,
          name: dataEdit.name,
          inputtype: dataEdit.input_type_id,
          unit: dataEdit.unit_type,
          projectgoal: null,
          realtaskgoals: 0,
          min: dataEdit.min,
          max: dataEdit.max,
          kpiName: dataEdit.kpi_type_name_en,
        })
        setEstimiteMin(dataEdit.min)
        setEstimiteMax(dataEdit.max)
      } else {
        form.setFieldsValue({
          kpitype: dataEdit.kpi_type,
          name: dataEdit.name,
          inputtype: dataEdit.input_type_id,
          unit: dataEdit.unit_type,
          projectgoal: dataEdit.goal,
          realtaskgoals: dataEdit.goal,
          retaskgoals: dataEdit.goal - dataEdit.usegoal,
          min: null,
          max: null,
          kpiName: dataEdit.kpi_type_name_en,
        })
        setEstimiteMin(0)
        setEstimiteMax(0)
      }
    } else {
      setFieldValueNull()
    }
  }
  const setFieldValueNull = () => {
    form.setFieldsValue({
      kpitype: null,
      name: null,
      inputtype: null,
      unit: null,
      projectgoal: null,
      realtaskgoals: 0,
      min: null,
      max: null,
      kpiName: null,
    })
    setEstimiteMin(0)
    setEstimiteMax(0)
  }

  const onCancel = () => {
    setFieldValueNull()
    setVisableModal(false)
    setSelectInputType(1)
  }

  const onFinish = (values) => {
    let idKPI
    if (stateKPI == 'project') {
      idKPI = 0
    } else {
      idKPI = stateKPI
    }
    if (values.inputtype === 23) {
      DataArray = {
        project_id: parseInt(idEditPRJ),
        sprintflow_id: idKPI,
        name: values.name,
        kpi_type: values.kpitype,
        unit_type: values.unit,
        goal: parseFloat(values.realtaskgoals),
        input_type_id: values.inputtype,
      }
    } else {
      DataArray = {
        project_id: parseInt(idEditPRJ),
        sprintflow_id: idKPI,
        name: values.name,
        kpi_type: values.kpitype,
        min: values.min,
        max: values.max,
        unit_type: values.unit,
        input_type_id: values.inputtype,
      }
    }
    if (typeBtn === 'add') {
      try {
        addKPIFinance({
          params: DataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getResultKpi()
            setFieldValueNull()
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      try {
        updateKpi({
          id: dataEdit.id,
          params: DataArray,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            getResultKpi()
            setFieldValueNull()
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
    setVisableModal(false)
  }

  // validate always value of min less than or equal max
  const onChangeValue = (field, value) => {
    const otherField = field === 'min' ? 'max' : 'min'
    const otherValue = Number(form.getFieldValue(otherField))
    const currentValue = Number(value)

    if (field === 'min' && (value === null || value === '')) {
      setMin(1)
      setEstimiteMin(0)
    } else {
      if (field === 'min') {
        setMin(currentValue)
        setEstimiteMin(currentValue)
      } else {
        setEstimiteMax(currentValue)
      }

      if (!isNaN(currentValue)) {
        if (field === 'min' && currentValue > otherValue) {
          setEstimiteMax(currentValue)
        } else if (field === 'max' && currentValue < otherValue) {
          setEstimiteMax(otherValue)
        }
      }
    }
  }

  return (
    <Modal
      maskClosable={false}
      title={
        <h2 className="Modaltitle" style={{ fontFamily: 'IBMPlexSansThaiBold' }}>
          {titlePage} {word['addtask_kpi_title_kpifinance']}
        </h2>
      }
      visible={visableModal}
      onOk={form.submit}
      onCancel={onCancel}
      okText="Save"
      okButtonProps={{ disabled: disableBtn }}
      className="editmodal edit-width dispalynoneupdowninputnumber"
      destroyOnClose
    >
      <Form form={form} onFinish={onFinish}>
        <Col span={24}>
          <h4 className="label">{word['addtask_kpi_title_kpitype']}</h4>
          <Form.Item
            name="kpitype"
            rules={[
              {
                required: true,
                message: word['Project_KPI/Finance_KPI_Type'],
              },
            ]}
          >
            <Select
              className="border"
              placeholder={kpiType.name_en}
              defaultValue={kpiType.name_en}
              size="large"
              key="kpiType"
              style={{ width: '100%' }}
            >
              {kpiType.map((item) => (
                <Option value={item.id}>
                  {language == 'en' ? item.name_en : item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <h4 className="label">{word['addtask_kpi_title_name']}</h4>
          <Form.Item
            name="name"
            rules={[
              {
                whitespace: true,
                required: true,
                message: word['Project_KPI/Finance_Name'],
              },
            ]}
          >
            <Input
              className="border"
              placeholder="Name"
              size="large"
              style={{ width: '100%' }}
            ></Input>
          </Form.Item>

          <h4 className="label">{word['addtask_kpi_title_inputtype']}</h4>
          <Form.Item
            name="inputtype"
            rules={[
              {
                required: true,
                message: word['Project_KPI/Finance_Input_type'],
              },
            ]}
          >
            <Select
              className="border"
              placeholder="InputType"
              size="large"
              style={{ width: '100%' }}
              onChange={onChangeInputType}
            >
              {inputType &&
                inputType.map((item) => (
                  <Option value={item.id}>
                    {language == 'en' ? item.name_en : item.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>

          {checkShowInputType(selectInputType)}

          <h4 className="label">{word['addtask_kpi_title_unit']}</h4>
          <Form.Item
            name="unit"
            rules={[
              {
                required: true,
                message: word['Project_KPI/Finance_Unit'],
              },
            ]}
          >
            <Select
              className="border"
              placeholder={unitType.name_en}
              defaultValue={unitType.name_en}
              size="large"
              key="unitType"
              style={{ width: '100%' }}
            >
              {unitType.map((item) => (
                <Option value={item.id}>
                  {language == 'en' ? item.name_en : item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  )
}
export default AddTaskKPIFinance
